export class HtmlBuilder {
  constructor(ids, classes, content) {
    this.ids = ids
    this.classes = classes
    this.content = content
  }

  build() {
    return `<h2
      id="${this.ids.id}"
      class="${this.classes.classes}"
    >${this.content.text}</h2>`
  }
}